


import 'react-datepicker/dist/react-datepicker.css';
import '../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../styles/index.css';

import LogRocket from 'logrocket';

import TenantService from "../utils/tenantService"
import { SessionProvider, useSession } from '../contexts/sessionContext';
import AppContextProvider from '../contexts/appContext';
import CatalogContextProvider from '../contexts/catalogContext';
import TenantContextProvider from '../contexts/tenantContext';
import { useEffect, useState } from 'react';
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { SELECTED_LANGUAGE } from '../constants';
import i18n_es from "../utils/i18n/i18n_es"
import i18n_en from "../utils/i18n/i18n_en"
import LoadingScreen from '../components/Loading';

function MyApp({ Component, pageProps }) {

  const [tenantData, setTenantData] = useState(null);
  const [tenantError, setTenantError] = useState(null);

  useEffect(() => {

    (async () => {
      try {
        let domain = process.env.NEXT_PUBLIC_TENANT_DOMAIN || "beta.optimacommerce.com"
        let currentTenant = await TenantService.findTenantByUrl(domain)
        setTenantData({ domain, currentTenant })
      } catch (error) {
        setTenantError(error.message || 'Error while loading the application.');
      }
    })();

    if (window.location.search) {
      const params = new URLSearchParams(location.search);
      if (params.get("externalId"))
        localStorage.setItem("externalId", params.get("externalId"));
      if (params.get("name"))
        localStorage.setItem("name", params.get("name"));
      if (params.get("helperButton"))
        localStorage.setItem("helperButton", params.get("helperButton"));
      if (params.get("logo"))
        localStorage.setItem("logo", params.get("logo"));
      if (params.get("notificationButton"))
        localStorage.setItem("notificationButton", params.get("notificationButton"));
      if (params.get("languageSelector"))
        localStorage.setItem("languageSelector", params.get("languageSelector"));
      if (params && params.get("lang")) {
        localStorage.setItem("language", params.get("lang"));


      }

      if (params.get("organizationFinder"))
        localStorage.setItem("organizationFinder", params.get("organizationFinder"));
      if (params.get("profile"))
        localStorage.setItem("profile", params.get("profile"));
      if (params.get("token"))
        localStorage.setItem("externalToken", "3x73rn41_" + params.get("token"));
      if (params.get("showNewTrip"))
        localStorage.setItem("showNewTrip", params.get("showNewTrip"));
    } else {
      localStorage.removeItem("externalId");
      localStorage.removeItem("name");
      localStorage.removeItem("helperButton");
      localStorage.removeItem("logo");
      localStorage.removeItem("notificationButton");
      localStorage.removeItem("languageSelector");
      localStorage.removeItem("lang");
      localStorage.removeItem("organizationFinder");
      localStorage.removeItem("profile");
      localStorage.removeItem("externalToken");
      localStorage.removeItem("showNewTrip");
    }
  }, [])
  const session = useSession();

  useEffect(() => {

    i18n
      .use(initReactI18next) // passes i18n down to react-i18next
      .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
          en: { 'translation': i18n_en },
          es: { 'translation': i18n_es },
        },
        lng: window.localStorage.getItem("language") || 'en',
        fallbackLng: "en",

      });
    // LogRocket.init('flexbpo/optima4');
  }, [])

  // let domain = await TenantService.getDomain(ctx)

  if (tenantError) {
    return (
      <div className="overflow-hidden absolute h-full w-full flex flex-col justify-center items-center gap-4 px-6 text-center">
        <h2 className="text-xl font-semibold text-gray-700">Error while loading the application</h2>
        <p className="text-red-600 max-w-md">{tenantError}</p>
        <button
          type="button"
          className="mt-2 px-4 py-2 bg-primary-400 text-white rounded hover:opacity-80"
          onClick={() => window.location.reload()}
        >
          Try again
        </button>
      </div>
    );
  }

  if (!tenantData) {
    return <div className="overflow-hidden absolute h-full w-full flex justify-center items-center">
      <LoadingScreen />
    </div>
  }


  return (
    <TenantContextProvider domain={tenantData.domain} currentTenant={tenantData.currentTenant}>
      <AppContextProvider>
        <CatalogContextProvider>
          <SessionProvider value={session}>
            <Component {...pageProps} />
          </SessionProvider>
        </CatalogContextProvider>
      </AppContextProvider>
    </TenantContextProvider>
  );
}


export default MyApp;